import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { usePageToolbar } from '@/core/hooks/usePageToolbar';

/**
 * Teleports approval actions into the header "Phê duyệt" submenu dropdown.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeaderApprovals',
  setup(__props) {

const { registerApprovalPanel, approvalOpen } = usePageToolbar();
const targetReady = ref(false);
let rafId = 0;

function waitForSlot() {
  if (document.getElementById('page-toolbar-approval-slot')) {
    targetReady.value = true;
    return;
  }
  rafId = requestAnimationFrame(waitForSlot);
}

function onMenuClick(event: MouseEvent) {
  const target = event.target as HTMLElement | null;
  if (target?.closest('button, a, [role="menuitem"]')) {
    approvalOpen.value = false;
  }
}

onMounted(() => {
  registerApprovalPanel(true);
  waitForSlot();
});

onBeforeUnmount(() => {
  targetReady.value = false;
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
  registerApprovalPanel(false);
});

return (_ctx: any,_cache: any) => {
  return (targetReady.value)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#page-toolbar-approval-slot"
      }, [
        _createElementVNode("div", {
          class: "page-header-approvals",
          role: "none",
          onClick: onMenuClick
        }, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})